function HomeIcon(props: React.SVGAttributes<{}>) {
    return (
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M11.25 15.7496V9.74963C11.25 9.55072 11.171 9.35996 11.0303 9.2193C10.8897 9.07865 10.6989 8.99963 10.5 8.99963H7.5C7.30109 8.99963 7.11032 9.07865 6.96967 9.2193C6.82902 9.35996 6.75 9.55072 6.75 9.74963V15.7496M2.25 7.49961C2.24995 7.28141 2.2975 7.06583 2.38934 6.8679C2.48118 6.66997 2.6151 6.49446 2.78175 6.35361L8.03175 1.85436C8.30249 1.62554 8.64552 1.5 9 1.5C9.35448 1.5 9.69751 1.62554 9.96825 1.85436L15.2183 6.35361C15.3849 6.49446 15.5188 6.66997 15.6107 6.8679C15.7025 7.06583 15.7501 7.28141 15.75 7.49961V14.2496C15.75 14.6474 15.592 15.029 15.3107 15.3103C15.0294 15.5916 14.6478 15.7496 14.25 15.7496H3.75C3.35218 15.7496 2.97064 15.5916 2.68934 15.3103C2.40804 15.029 2.25 14.6474 2.25 14.2496V7.49961Z"
                stroke="#767F91"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

export default HomeIcon;
